import { render } from "./ActionDropdown.vue?vue&type=template&id=5e51ef2f&scoped=true"
import script from "./ActionDropdown.vue?vue&type=script&lang=js"
export * from "./ActionDropdown.vue?vue&type=script&lang=js"

import "./ActionDropdown.vue?vue&type=style&index=0&id=5e51ef2f&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e51ef2f"]])

export default __exports__